import { makeStyles } from "@material-ui/core/styles";
import { red } from "@material-ui/core/colors";

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 275,
    maxHeight: "63vh",
    margin: 12,
  },
  media: {
    height: 4,
    paddingTop: "28%",
  },
  avatar: {
    backgroundColor: red[400],
  },
}));

export { useStyles };
